import { companyApis } from '@apis/dashboard/companyApis';
import { useQuery } from '@hooks/useQuery';

export const useCompanyChecklist = (id: number) => {
  return useQuery([`/dashboard/company/${id}/checklist/`], () =>
    companyApis
      .get('/dashboard/company/{id}/checklist/', {
        path: { id },
      })
      .then((r) => r[200]!),
  );
};
